import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAr0mSPMAw-h-liCS02aqtYGMaS5rTEhmM",
  authDomain: "portfolio-4a58e.firebaseapp.com",
  databaseURL: "https://portfolio-4a58e.firebaseio.com",
  projectId: "portfolio-4a58e",
  storageBucket: "portfolio-4a58e.appspot.com",
  messagingSenderId: "261909390973",
  appId: "1:261909390973:web:0fd489c55074dcfc1af314",
};

firebase.initializeApp(firebaseConfig);

function sendMessageToDB(message) {
  return firebase
    .firestore()
    .collection("messages")
    .doc()
    .set({
      name: message.name,
      email: message.email,
      message: message.message,
      date: firebase.firestore.Timestamp.fromDate(message.date),
    })
    .then(() => true)
    .catch((error) => {
      console.error(error);
      return false;
    });
}

export { sendMessageToDB };
